<script>
		import { user } from "../client.svelte.js";
		import Catalog from "../elements/Catalog.svelte";
		import FshpCard from "../elements/FshpCard.svelte";
		import {select_fellowship } from "./_Narrate.svelte";

		let fellowships = $derived(user.fellowships.values()
				.filter(fshp => fshp.ID !== 'DEMO')
				.toArray()
				.sort((a, b) => a.ID.localeCompare(b.ID)))

		/// only groups with entries are shown in the catalog
		let grpdEntries = $derived(Object.fromEntries([
				["Meine Gruppen (Admin)", fellowships.filter(fshp => fshp.admin === user.ID)],
				["Gruppen, in denen ich Mitglied bin", fellowships.filter(fshp => fshp.admin !== user.ID && fshp.members?.includes(user.ID))],
			].filter(([group, entries]) => entries.length > 0)))

		async function select() {
				await select_fellowship(this.ID)
				view.switch_layout('game-fellowship')
		}
</script>


<!-------------------------------- HTML -------------------------------------->

<article>
	<h2 class="page-title">Gruppenübersicht</h2>
	{#if Object.keys(grpdEntries).length}
		<Catalog Card={FshpCard} {grpdEntries} onselect={select}/>
	{:else}
		<p class="card-meta">Du bist noch in keiner Gruppe. Lege eine neue Gruppe an oder lass Dich vom Admin einer Gruppe einladen.</p>
	{/if}
</article>
